var exports = {
  "OS": "Metadata__SryGWL",
  "mj": "Attribution__rgNajd",
  "Ag": "Actor__ZB78FK",
  "az": "Login__y9aaC9",
  "B_": "Details__bno3v8",
  "kZ": "Detail__29MvR8",
  "yv": "DetailLabel__csXrwV",
  "Jw": "DetailValue__yMr1Kf",
  "$R": "Sha__-f9qUy",
};

module.exports = exports;
